import $ from 'jquery'

const mobileBreakpoint = 992

function isMobile() {
  return window.innerWidth < mobileBreakpoint
}

$(function () {
  let activeClass = 'search-mode'
  let $wrap = $('.header-wrap')
  let $section = $('section.main')
  let $input = $('#mainsearch')
  let open = function () {
    $wrap.addClass(activeClass)
    $section.css('margin-top', $('header.main').innerHeight())
    $input.focus()
  }
  let close = function () {
    $wrap.removeClass(activeClass)
    $section.css('margin-top', '0px')
  }

  $('.search-button').on('click', function () {
    if (isMobile()) {
      open()
    } else {
      if (!$wrap.hasClass(activeClass)) {
        open()
      } else {
        close()
      }
    }
  })

  $('.search-form').on('click', function (e) {
    e.stopPropagation()
    if (e.target === e.currentTarget) {
      close()
    }
  })
})
